export class AdditionalFile {
    public FileName:string;

    public FileData:string;

    public FileSize:string;

    public FileType:string;

    public FileCategory:string;


    /**
     *
     */
    constructor(fileName?:string, fileData?:string, fileSize?:string, fileType?:string,fileCategory?:string) { 
        this.FileName = fileName;
        this.FileData= fileData;
        this.FileSize = fileSize; 
        this.FileType = fileType;       
        this.FileCategory = fileCategory;
    }
    
}